var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "product-carousel" },
    [
      _vm.multipleImages && "mobile" !== _vm.$mq
        ? _c("icon-button", {
            staticClass: "product-carousel__prev",
            attrs: {
              label: "Next Slide",
              icon: "chevron-left-big",
              size: "64px",
            },
            on: {
              click: function ($event) {
                return _vm.$refs.productImageCarousel.slidePrev()
              },
            },
          })
        : _vm._e(),
      _vm.multipleImages && "mobile" !== _vm.$mq
        ? _c("icon-button", {
            staticClass: "product-carousel__next",
            attrs: {
              label: "Previous Slide",
              icon: "chevron-right-big",
              size: "64px",
            },
            on: {
              click: function ($event) {
                return _vm.$refs.productImageCarousel.slideNext()
              },
            },
          })
        : _vm._e(),
      _vm.product.images
        ? _c(
            "carousel",
            {
              key: _vm.currentVariantId,
              ref: "productImageCarousel",
              attrs: {
                "slides-to-show": 1,
                infinite: true,
                dots: true,
                "thumbnail-images": !["mobile", "tablet"].includes(_vm.$mq)
                  ? _vm.thumbnailImages
                  : [],
              },
            },
            _vm._l(_vm.images, function (image, index) {
              return _c(
                "slide",
                { key: index },
                [_c("product-carousel-image", { attrs: { image: image } })],
                1
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }